// If they are: they proceed to the page
// If not: they are redirected to the login page.
import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import SessionManager from '../../custom-classes/session-manager';
/**
 * Manages the Private routes. DO NOT delete this class
 * @param Component
 * @param rest
 * @returns {XML}
 * @constructor
 */
const EmployeeRoute = ({ component: Component, ...rest }) => {

    // Add your own authentication on the below line.
    const isLoggedIn = SessionManager.evaluateSessionEmployee();
    return (
        <Route
            {...rest}
            render={props =>
                isLoggedIn ? (
                    <Component {...props} />
                ) : (
                    <Redirect to={{ pathname: '/login-employee', state: { from: props.location } }} />
                )
            }
        />
    )
};

export default EmployeeRoute;